import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../../../shared/utils/index.js";
import { ChevronLeft, X } from "lucide-react";
import { useModalStore } from "../../stores/index.js";
const ModalHeader = t0 => {
  const $ = _c(11);
  const {
    showBackButton: t1,
    handleBack,
    handleClose,
    title,
    children,
    showCloseButton: t2,
    className,
    showBackWord: t3
  } = t0;
  const showBackButton = t1 === undefined ? true : t1;
  const showCloseButton = t2 === undefined ? true : t2;
  const showBackWord = t3 === undefined ? false : t3;
  const navigateBack = useModalStore(_temp);
  const setB3ModalOpen = useModalStore(_temp2);
  let t4;
  if ($[0] !== children || $[1] !== className || $[2] !== handleBack || $[3] !== handleClose || $[4] !== navigateBack || $[5] !== setB3ModalOpen || $[6] !== showBackButton || $[7] !== showBackWord || $[8] !== showCloseButton || $[9] !== title) {
    t4 = _jsxs("div", {
      className: cn("b3-modal-header flex h-16 items-center justify-between border-b border-[#e4e4e7] bg-white px-5 py-3", className),
      children: [showBackButton ? _jsxs("button", {
        onClick: handleBack || navigateBack,
        className: "flex h-6 w-6 items-center justify-center transition-opacity hover:opacity-70",
        children: [_jsx(ChevronLeft, {
          className: "h-6 w-6 text-[#51525c] dark:text-white"
        }), showBackWord && _jsx("span", {
          className: "text-sm font-medium",
          children: "Back"
        })]
      }) : _jsx("div", {
        className: "w-2"
      }), _jsx("p", {
        className: "font-inter text-lg font-semibold leading-7 text-[#18181b] dark:text-white",
        children: title
      }), showCloseButton ? _jsx("button", {
        onClick: handleClose || (() => setB3ModalOpen(false)),
        className: "flex h-6 w-6 items-center justify-center transition-opacity hover:opacity-70",
        children: _jsx(X, {
          className: "h-6 w-6 text-[#51525c] dark:text-white"
        })
      }) : !children ? _jsx("div", {
        className: "w-2"
      }) : undefined, children]
    });
    $[0] = children;
    $[1] = className;
    $[2] = handleBack;
    $[3] = handleClose;
    $[4] = navigateBack;
    $[5] = setB3ModalOpen;
    $[6] = showBackButton;
    $[7] = showBackWord;
    $[8] = showCloseButton;
    $[9] = title;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default ModalHeader;
function _temp(state) {
  return state.navigateBack;
}
function _temp2(state_0) {
  return state_0.setB3ModalOpen;
}